export default "__VITE_ASSET__CEeYKN60__"